import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Reason } from '../../../../../../core/lists/_models/reason.model';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { StringUtilsService } from '../../../../../../core/services/string-utils.service';
import { AppState } from '../../../../../../core/reducers';
import { BehaviorSubject, Observable } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { ReasonService } from '../../../../../../core/lists/_services/reasons.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-reason-edit',
  templateUrl: './reason-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReasonEditComponent implements OnInit, OnDestroy {
  reason: Reason;
  companyId: number;
  loadingSubject = new BehaviorSubject<boolean>(true);
  loading$: Observable<boolean>;
  reasonForm: FormGroup;
  hasFormErrors = false;
  submissionErrorObj: any;
  hasSubmissionErrors: boolean;
  subscriptions = [];

  constructor(
    public dialogRef: MatDialogRef<ReasonEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>,
    private router: Router,
    private reasonFB: FormBuilder,
    private reasonService: ReasonService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    private layoutUtilsService: LayoutUtilsService,
    public stringUtils: StringUtilsService,
  ) {}

  ngOnInit() {
    this.createForm();
  }

  getTitle() {
    if (this.data.mode === 'CREATE') return 'New Reason';
    return 'Update Reason - ' + this.data.reason.reason;
  }

  ngOnDestroy() {
    this.cdr.detach();
    this.subscriptions.forEach((el) => {
      if (el.sub) {
        el.sub.unsubscribe();
      }
    });
  }

  createForm() {
    this.reasonForm = this.reasonFB.group({
      reason: [this.data.reason ? this.data.reason.reason : null],
    });
  }

  onSubmit() {
    this.hasFormErrors = false;
    const controls = this.reasonForm.controls;
    if (this.reasonForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    }
    if (this.data.mode === 'CREATE') {
      this.addReason(this.prepareReason());
      return;
    }
    this.updateReason(this.prepareReason());
  }

  prepareReason(): Reason {
    const controls = this.reasonForm.controls;
    const _reason = new Reason();
    if (this.data.mode === 'UPDATE') {
      _reason.id = this.data.reason.id;
    }
    _reason.reason = controls.reason.value;
    return _reason;
  }

  addReason(_reason) {
    const request = {
      reason: _reason.reason,
    };
    this.reasonService.createReason(request).subscribe(() => {
      this.layoutUtilsService.showActionNotification(
        'Reason Added Successfully',
        MessageType.Update,
        3000,
        false,
        false,
      );
      this.dialogRef.close();
    });
  }

  updateReason(_reason) {
    const request = {
      id: _reason.id,
      reason: _reason.reason,
    };
    for (const [key, value] of Object.entries(request)) {
      if (typeof value === 'string') {
        request[key] = value.trim();
      }
    }
    this.reasonService.updateReason(request).subscribe(() => {
      this.layoutUtilsService.showActionNotification(
        'Reason Updated Successfully',
        MessageType.Update,
        3000,
        false,
        false,
      );
      this.dialogRef.close();
    });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.reasonForm.controls[controlName];
    if (!control) {
      return false;
    }
    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  close() {
    this.dialogRef.close();
  }
}
